import React, { useContext, useState } from "react";
import Link from "next/link";
import { analyticsEvents, track } from "util/analytics";
import QueryManagerContext from "context/QueryManager/QueryManagerContext";
import { publicListingNiceSearch_publicListingNiceSearch_listings_nodes } from "../Listings/types/publicListingNiceSearch";
import ListingCard from "./SelectedListingCard";
import styles from "./styles.module.scss";
import BaseMap from "../../GoogleMap/BaseMap";
import BaseMarker from "../../GoogleMap/BaseMarker";

const getSelectedListing = (
  listings: publicListingNiceSearch_publicListingNiceSearch_listings_nodes[],
  id: string
) => listings.find((listing) => listing.id === id);

interface IProps {
  hoveredListingId: string | null;
}

const Map = ({ hoveredListingId }: IProps) => {
  const [selectedListingId, setSelectedListingId] = useState<string | null>(
    null
  );
  const {
    values: {
      listings,
      market,
      leaseTermMin,
      leaseTermMax,
      minPricePerSquareFoot,
      maxPricePerSquareFoot,
      minSqft,
      maxSqft,
      minMonthlyPrice,
      maxMonthlyPrice,
      numEmployees,
      neighborhoods,
      submarkets,
    },
  } = useContext(QueryManagerContext);

  const onClick = (id: string) => setSelectedListingId(id);

  const selectedListing = selectedListingId
    ? getSelectedListing(listings, selectedListingId)
    : null;

  return (
    <div className={styles.container}>
      {selectedListing && (
        <div className={styles.selectedListing}>
          <Link
            passHref
            href={`/building${selectedListing.building.slug}/${selectedListing.building.identity}?listingId=${selectedListing.id}`}
          >
            <a>
              <ListingCard
                listing={selectedListing}
                signUpType="Public Search"
                source="Bookmark - Map"
                areaExternalIds={[
                  ...neighborhoods.map(({ externalId }) => externalId),
                  ...submarkets.map(({ externalId }) => externalId),
                ]}
                marketOfInterest={market.externalId}
                leaseTermMin={leaseTermMin}
                leaseTermMax={leaseTermMax}
                minPricePerSquareFoot={minPricePerSquareFoot}
                maxPricePerSquareFoot={maxPricePerSquareFoot}
                minSqft={minSqft}
                maxSqft={maxSqft}
                minMonthlyPrice={minMonthlyPrice}
                maxMonthlyPrice={maxMonthlyPrice}
                numEmployees={numEmployees}
                phoneRequired={false}
                onSuccess={() => {}}
                trackingEvent={() =>
                  track(analyticsEvents.clicked, {
                    category: "Public Search CTAs",
                    label: "Bookmark",
                  })
                }
              />
            </a>
          </Link>
        </div>
      )}
      <BaseMap autoCenter>
        {listings.map(
          ({
            id,
            accurateMonthlyPrice,
            displayMonthlyPrice,
            status,
            building: { lat, lng },
          }) => (
            <BaseMarker
              key={`marker-${id}`}
              latitude={lat}
              longitude={lng}
              id={id}
              className={`${styles.marker} ${
                hoveredListingId === id ? styles.hoveredMarker : ""
              }`}
              onClick={() => onClick(id)}
            >
              {accurateMonthlyPrice &&
              displayMonthlyPrice &&
              status &&
              status !== "UNAVAILABLE"
                ? displayMonthlyPrice
                : "Inquire"}
            </BaseMarker>
          )
        )}
      </BaseMap>
    </div>
  );
};

export default Map;
